'use strict';

var React = require('react');

var SvgTextInColumnsIcon = function SvgTextInColumnsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5.75c0-.966.784-1.75 1.75-1.75h3.25c.966 0 1.75.784 1.75 1.75v3a1.75 1.75 0 0 1-1.75 1.75h-3.25a1.75 1.75 0 0 1-1.75-1.75v-3Zm1.75-.25a.25.25 0 0 0-.25.25v3c0 .138.112.25.25.25h3.25a.25.25 0 0 0 .25-.25v-3a.25.25 0 0 0-.25-.25h-3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.5a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 0 1.5h-5.25a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.5a.75.75 0 0 0 0 1.5h2.625a.75.75 0 0 0 0-1.5h-2.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 14.5a.75.75 0 0 0 0 1.5h2.625a.75.75 0 0 0 0-1.5h-2.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11.75a.75.75 0 0 0 0 1.5h5.25a.75.75 0 0 0 0-1.5h-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 4a1.75 1.75 0 0 0-1.75 1.75v3c0 .966.784 1.75 1.75 1.75h3.25a1.75 1.75 0 0 0 1.75-1.75v-3a1.75 1.75 0 0 0-1.75-1.75h-3.25Zm-.25 1.75a.25.25 0 0 1 .25-.25h3.25a.25.25 0 0 1 .25.25v3a.25.25 0 0 1-.25.25h-3.25a.25.25 0 0 1-.25-.25v-3Z"
  }));
};
SvgTextInColumnsIcon.displayName = "TextInColumnsIcon";

exports.SvgTextInColumnsIcon = SvgTextInColumnsIcon;
